import sha256 from 'crypto-js/sha256';
import Base64 from 'crypto-js/enc-base64';

/**
 *  Default OIDC config for development (localhost)
 * b30a412c-f8f1-e6d1-1e4dabd5693a3d21f316c203651e46b2
 * cd337e48-6363-665b-273ca0b2fd742230d6beb16b21d32c45
 * OAMAzureOAuthOidcExample
 */

const OIDC_CONFIG_DEV = {

  oauth_client_id: '5162577-7446-2683-43942625973343453747a516e53413d3d',
  oauth_client_secret: '57586e666271745a6c314c2f49737a3168422f596f413d3d',
  oauth_domain: 'Archi',
  oauth_login_url: 'https://dev.auth.highmark.com/oauth2/rest/authz',
  oauth_token_url: 'https://dev.auth.highmark.com/oauth2/rest/token',
  oauth_callback_url: 'https://localhost:4200/oauth/callback',
  oauth_userinfo_endpoint: 'https://dev.auth.highmark.com/oauth2/rest/userinfo',
  app_login_url: 'https://localhost:4200',
  scope: 'resource.READ'
};


const OIDC_CONFIG_DEV_WORKS= {

  oauth_client_id: 'b30a412c-f8f1-e6d1-1e4dabd5693a3d21f316c203651e46b2',
  oauth_client_secret: 'cd337e48-6363-665b-273ca0b2fd742230d6beb16b21d32c45',
  oauth_domain: 'OAMAzureOAuthOidcExample',
  oauth_login_url: 'https://test.auth.highmark.com/oauth2/rest/authz',
  oauth_token_url: 'https://lab.auth.highmark.com/oauth2/rest/token',
  oauth_callback_url: 'https://localhost:4200/oauth/callback',
  oauth_userinfo_endpoint: 'https://lab.auth.highmark.com/oauth2/rest/userinfo',
  app_login_url: 'https://localhost:4200',
  scope: 'resource.READ'
};

/**
 * OIDC config for production (test.conversation.goengen.com)
 */

const OIDC_CONFIG_TEST = {

  oauth_client_id: 'b30a412c-f8f1-e6d1-1e4dabd5693a3d21f316c203651e46b2',
  oauth_client_secret: 'cd337e48-6363-665b-273ca0b2fd742230d6beb16b21d32c45',
  oauth_domain: 'OAMAzureOAuthOidcExample',
  oauth_login_url: 'https://test.auth.highmark.com/oauth2/rest/authz',
  oauth_token_url: 'https://test.auth.highmark.com/oauth2/rest/token',
  oauth_callback_url: 'https://test.conversation.goengen.com/oauth/callback',
  oauth_userinfo_endpoint: 'https://test.auth.highmark.com/oauth2/rest/userinfo',
  app_login_url: 'https://test.conversation.goengen.com',
  scope: 'resource.READ'
};

const OIDC_CONFIG_TEST_ARCHI = {
  oauth_client_id: '5162577-7446-2683-43942625973343453747a516e53413d3d',
  oauth_login_url: 'https://test.auth.highmark.com/oauth2/rest/authz',
  oauth_token_url: 'https://test.auth.highmark.com/oauth2/rest/token',
  oauth_callback_url: 'https://test.conversation.goengen.com/oauth/callback',
  oauth_domain: 'Archi',
  oauth_client_secret: '57586e666271745a6c314c2f49737a3168422f596f413d3d',
  oauth_userinfo_endpoint: 'https://test.auth.highmark.com/oauth2/rest/userinfo',
  app_login_url: 'https://test.conversation.goengen.com',
  scope: 'resource.READ'
};


let currentConfig = OIDC_CONFIG_DEV_WORKS;
if (window.location.hostname === 'test.conversation.goengen.com') {
  currentConfig = OIDC_CONFIG_TEST;
}

/**
 * 
 * @param {*} length 
 * @returns 
 */
export const generateRandomString = (length) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return Base64.stringify(sha256(result));
};


/**
 * Generates a random code verifier string.
 * This function mirrors the Java code:
 * public static String generateCodeVerifier() {
 *     SecureRandom secureRandom = new SecureRandom();
 *     byte[] codeVerifierBytes = new byte[128];
 *     secureRandom.nextBytes(codeVerifierBytes);
 *     return Base64.getUrlEncoder().withoutPadding().encodeToString(codeVerifierBytes);
 * }
 *
 * @returns {string} A random code verifier string.
 */
export const generateCodeVerifier = () => {
  // Generate 128 random bytes (equivalent to the Java code)
  const randomBytes = generateRandomString(128);
  console.log(randomBytes);
  // Convert the random bytes to a Base64 URL-encoded string without padding
  const codeVerifier = randomBytes;
  return codeVerifier;
};

/**
 * Generates a code challenge from a code verifier using SHA-256 and Base64 URL encoding.
 * This function mirrors the Java code:
 * MessageDigest messageDigest = MessageDigest.getInstance("SHA-256");
 * byte[] hashedBytes = messageDigest.digest(codeVerifier.getBytes(StandardCharsets.UTF_8));
 * return Base64.getUrlEncoder().withoutPadding().encodeToString(hashedBytes);
 *
 * @param {string} codeVerifier - The code verifier string.
 * @returns {string} The code challenge string.
 */
export const generateCodeChallenge = (codeVerifier) => {
  // 1. Hash the code verifier using SHA-256.
  const hashed = sha256(codeVerifier);

  // 2. Convert the hashed result to a Base64 URL-encoded string without padding.
  const base64UrlEncoded = Base64.stringify(hashed)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');

  return base64UrlEncoded;
};


/**
 * 
 */
export const handleLogin = () => {
  console.log("handleLogin");
  const state = generateRandomString(40);
  const codeVerfifer = generateCodeVerifier();

  const codeChallenge = generateCodeChallenge(codeVerfifer);
  
  
  sessionStorage.setItem("oidc_state", state);
  sessionStorage.setItem("code_verifier", codeVerfifer);

  sessionStorage.setItem("code_challenge", codeChallenge);

  const authUrl = new URL(currentConfig.oauth_login_url);
  authUrl.searchParams.append("response_type", "code");
  authUrl.searchParams.append("scope", currentConfig.scope);
  authUrl.searchParams.append("domain", currentConfig.oauth_domain);
  authUrl.searchParams.append("client_id", currentConfig.oauth_client_id);
  authUrl.searchParams.append("secret", currentConfig.oauth_client_secret);
  authUrl.searchParams.append("code_challenge", codeChallenge);
  authUrl.searchParams.append("code_challenge_method", "S256");
  authUrl.searchParams.append("redirect_uri", currentConfig.oauth_callback_url);
  window.location.href = authUrl.toString();
};

/**
 * 
 * @param {*} code 
 * @returns 
 */
export const exchangeCodeForToken = async (code) => {

  const codeVerifier = sessionStorage.getItem("code_verifier");
  console.log(codeVerifier);
  const params = new URLSearchParams();
  params.append("client_id", currentConfig.oauth_client_id);
  //params.append("client_secret", currentConfig.oauth_client_secret);
  params.append("code", code);
  params.append("grant_type", "authorization_code");
  params.append("redirect_uri", currentConfig.oauth_callback_url);
  params.append("code_verifier", codeVerifier);

  try {
    const response = await fetch(currentConfig.oauth_token_url, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded", "x-oauth-identity-domain-name": currentConfig.oauth_domain, },
      body: params,
    });

    if (!response.ok) {
        let errorMessage = `Error exchanging code for token. Status: ${response.status}`;
        try {
            const errorData = await response.json();
            errorMessage += `. Message: ${errorData.error_description || errorData.error || 'Unknown error'}`;

        } catch (parseError) {
            console.error("Failed to parse error response:", parseError)
            errorMessage += ". Could not get detailed error message"
        }
        throw new Error(errorMessage);
    }

    return await response.json();
  } catch (error) {
    console.error("Error in exchangeCodeForToken:", error);
    throw error; // Re-throw to be handled upstream
  }
};

/**
 * 
 * @param {*} token 
 * @returns 
 */
export const getUserInfo = async (token) => {
  try {
    const response = await fetch(currentConfig.oauth_userinfo_endpoint, {
      headers: { Authorization: `Bearer ${token}`,"x-oauth-identity-domain-name": currentConfig.oauth_domain },
    });

    if (!response.ok) {
      let errorMessage = `Error fetching user info. Status: ${response.status}`;
      try {
        const errorData = await response.json();
        errorMessage += `. Message: ${errorData.error_description || errorData.error || 'Unknown error'}`;
      } catch (parseError) {
        console.error("Failed to parse error response:", parseError);
        errorMessage += ". Could not get detailed error message";
      }
      throw new Error(errorMessage);
    }

    return await response.json();
  } catch (error) {
    console.error("Error in getUserInfo:", error);
    throw error; // Re-throw to be handled upstream
  }
};

/**
 * 
 * @param {*} app_login_url 
 */
export const handleLogout = (app_login_url) => {
  sessionStorage.clear();
  window.location.href = currentConfig.app_login_url;
};



export const oidc_config = currentConfig;
